(function ($, Promise) {

	// Constructor
	function Serial(serialMapFile) {

		this.dispatcher = $({});

		// Load JSON for ZONES
		$.ajax({
			url: serialMapFile,
			dataType: 'json',
			cache: false,
			success: $.proxy(this.initSerial, this),
			error: $.proxy(function () {
				console.error("Couldn't load serial key map.")
			}, this),
		});

	}

	Serial.prototype.initSerial = function (keyMap) {

		var isNWJS = (typeof nw != "undefined") ? true : false;

		if (isNWJS) {

			// Load serial port library
			var SerialPort = require("serialport");

			// List available ports
			var serialsToUse = [];

			SerialPort.list($.proxy(function (err, ports) {

				try {
					ports.forEach(function (port) {

						var id = (typeof port.pnpId != "undefined") ? port.pnpId : port.comName;

						// List available serial ports
						console.log(port.comName + " (" + id + ") available.", port);

						// If manufacturer contains ARDUINO, make a connection
						if (typeof port.manufacturer != "undefined" && port.manufacturer.toLowerCase().indexOf("arduino") !== -1) {
							serialsToUse.push(port.comName);
						}
					});

					// Add all serials if no Arduinos are found
					if (serialsToUse.length == 0) {
						ports.forEach(function (port) {
							serialsToUse.push(port.comName);
						});
					}

					// Init serial ports servers
					this.startSerialServers(serialsToUse, SerialPort, keyMap);

				} catch (err) {
					console.error(err);
				}

			}, this));
		}

	};


	Serial.prototype.startSerialServers = function (serialPortNames, SerialPort, keyMap) {

		// Load serial port library
		console.log("serial port to create", serialPortNames, keyMap);

		this.serialports = [];
		this.serialportsPasers = [];

		var serialButttonMap = Object.values(keyMap["serial-buttons-map"]);
		var serialButttonMapKeys = Object.keys(keyMap["serial-buttons-map"]);

		// Go through each defined serial port
		for (var i = 0; i < serialPortNames.length; i++) {

			// Create new parser
			// https://arduino.stackexchange.com/questions/42883/sending-string-over-serial-to-nodejs-app-why-does-it-get-chunked
			this.serialportsPasers.push(new SerialPort.parsers.Readline("\n"));

			// Create an instance to each port defined in settings.json
			this.serialports.push(new SerialPort(serialPortNames[i], {
				baudRate: 9600,
				autoOpen: false,
			}));

			this.serialports[i].pipe(this.serialportsPasers[i])

			console.log('Initializing serial Port using : ' + serialPortNames[i]);

			// Bind events : open
			this.serialports[i].on('open', $.proxy(function (port) {
				console.log('SerialPort open', port);
			}, this, this.serialports[i]));

			// Bind events : on parser data
			this.serialportsPasers[i].on('data', $.proxy(function (port, data) {
				try {
					var receivedString = ("" + data.toString()).trim();
					var interestSting = receivedString.substring(0, receivedString.lastIndexOf("_"));
					console.log('SerialPort receivedString ' + receivedString + ". String of interest is " + interestSting + ".");
					for (var i = serialButttonMap.length - 1; i >= 0; i--) {
						if (interestSting == serialButttonMap[i]) {
							var actionId = serialButttonMapKeys[i];
							var event = $.Event('action');
							event.actionId = actionId;
							event.actionValue = receivedString.replace(serialButttonMap[i], "");
							this.dispatcher.trigger(event);
							break;
						}
					}

				} catch (e) {
					console.log("error", e);
				}

			}, this, this.serialports[i]));

			// Bind events : error
			this.serialports[i].on('error', $.proxy(function (prt, err) {
				console.log('SerialPort error', port, err);
			}, this, this.serialports[i]));

			// Bind events : close
			this.serialports[i].on('close', $.proxy(function (port) {
				console.log('SerialPort close', port);

				// try to reconnect it
				var reconnect = setInterval($.proxy(function (port) {

					port.open(function (err) {
						console.log("Trying to reopen port...", port);

						if (err) {
							return console.log('Error opening port: ', err.message);
						}
						else {
							clearInterval(reconnect);
							return console.log('Successfully reopened port!', port);
						}
					});

				}, this, port), 5000);

			}, this, this.serialports[i]));

			// Bind events
			this.serialports[i].on('disconnect', $.proxy(function (port) {
				console.log('SerialPort disconnect', port);
			}, this, this.serialports[i]));
		}

		// Go through each defined serial port and open connections
		for (var i = 0; i < serialPortNames.length; i++) {
			this.serialports[i].open(function (err) {
				if (err) {
					return console.log('Error opening port: ', err.message);
				}
				// Because there's no callback to write, write errors will be emitted on the port:
				// this.serialports[i].write('main screen turn on');
			});
		}

	}

	Serial.prototype.on = function () {
		this.dispatcher.on.apply(this.dispatcher, arguments)
	}

	// Expose Timeline
	window.Serial = Serial;

})
(jQuery, Promise);